import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {RouteName} from '@app/app.route-names.generated';
import {TextButtonComponent} from '@aviary/buttons/text-button/text-button.component';
import {ButtonRouteNameDirective} from '@lib/directives/button-route-name/button-route-name.directive';
import {ButtonLabelSize} from '@aviary/buttons/button.types';
import {Params} from '@angular/router';

export type ArrowDirection = 'back' | 'forward';

@Component({
  selector: 'px-arrow-text-button',
  template: `
    <!-- beforeLabel and afterLabel are Unicode arrows that fit better than the Material icons at smaller screen sizes.-->
    @if (direction === 'back') {
      <mx-text-button [routeName]="routeName" [routeParams]="routeParams"
                      startIcon="arrow_back" startIconClasses="hidden md:block"
                      beforeLabel="&#11104;" beforeLabelClasses="md:hidden"
                      [label]="label" [labelSize]="labelSize"/>
    } @else {
      <mx-text-button [routeName]="routeName" [routeParams]="routeParams"
                      [label]="label" [labelSize]="labelSize"
                      afterLabel="&#10141;" afterLabelClasses="md:hidden"
                      endIcon="arrow_forward" endIconClasses="hidden md:block"/>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TextButtonComponent, ButtonRouteNameDirective]
})
export class ArrowTextButtonComponent {

  @Input({required: true}) public label: string;
  @Input() public routeName?: RouteName;
  @Input() public routeParams: Params = {};
  @Input() public direction: ArrowDirection = 'forward';
  @Input() public labelSize: ButtonLabelSize = 'default';
}
